<template>

  <div class="LoginBox">
    <div v-if="$route.query.loginType"></div>
    <div id="login" v-else>
      <el-alert title="" type="warning" style="cursor: pointer;" v-if="noticeShow" :closable="false" >
        <div class="importantNote" @click="noticeDialog = true">
          <img src="../assets/img/notice_icon.png" alt="" style="width: 20px;">
          <span>{{notice.title| ellipsis}}</span>
          <span style="margin-left: 16px;">（ {{notice.releaseTime.slice(0, 10)}} ）</span>
        </div>
      </el-alert>

      <div style="width: 100%;height: 100%;" class="NewLogin">
        <!-- LOGO -->
        <div class="NewLogo">
          <img :src="requestForm.logoUrl" alt="" />
        </div>
        <div class="NewMainLogin">
          <!-- Swiper -->
          <div class="NewLeft">
            <div class="NewSwiper">
              <el-carousel :interval="8000" arrow="always">
                <el-carousel-item
                  v-for="(item, index) in requestForm.backgroundVoList"
                  :key="index"
                  v-show="false"
                  :style="{ background: `url(${item.imageUrl}) top center no-repeat`, 'background-size': 'auto 100%' }"
                >
                  <div class="SwiperText">
                    <h1 class="SwiperTitle">{{ item.imageTitle }}</h1>
                    <p class="SwiperDes">{{ item.imageSubtitle }}</p>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <!-- Login -->
          <div class="NewRight">
            <!-- 系统名称 -->
            <!-- <h1>
              {{ requestForm.systemName }}
              <br />
              <span v-html="requestForm.loginPageTitle" v-if="requestForm.loginPageTitle"></span>
            </h1> -->
            <div class="loginPageTitle">
              <span v-html="requestForm.loginPageTitle" v-if="requestForm.loginPageTitle"></span>
            </div>
            <!-- 登录方式切换按钮 -->
            <div class="changeBtn changeBenFirst" v-if="getShowNavigation">
              <span @click="changeMode('account')" :class="{ active: isActive, account: true }">账号登录</span>
              <div v-if="isMastPhone">
                <span class="changeCenter">|</span>
                <span @click="changeMode('verification')" :class="{ active: isVerification, verification: true }">手机号登录</span>
              </div>
              <div v-if="isMastEmail">
                <span class="changeCenter">|</span>
                <span @click="changeMode('emailVerification')" :class="{ active: isEmailVerification, emailVerification: true }">邮箱登录</span>
              </div>
            </div>
            <div class="changeBtn" v-else></div>
            <!-- 登录表单 -->
            <el-form
              :model="isActive ? ruleForm   : (isVerification ? phoneRuleForm : emailRuleForm)"
              :rules="isActive ? rules      : (isVerification ? phoneRules : emailRules)"
              :ref  ="isActive ? 'ruleForm' : (isVerification ?'phoneRuleForm' : 'emailRuleForm')"
              label-width="100px"
              class="demo-ruleForm"
            >
              <!-- 账号登录 -->
              <div v-if="isActive">
                <el-form-item prop="userName">
                  <el-input v-model="ruleForm.userName" placeholder="请输入用户名 ( 学生证件号 )"></el-input>
                  <img src="../assets/img/login-username-icon.png" class="login-icon"/>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input v-model="ruleForm.password" type="password" placeholder="请输入密码"></el-input>
                  <img src="../assets/img/login-password-icon.png" class="login-icon" />
                </el-form-item>
                <el-form-item prop="imageCheckCode">
                  <el-input v-model="ruleForm.imageCheckCode" placeholder="请输入验证码"></el-input>
                  <img src="../assets/img/login-code-icon.png" class="login-icon"/>
                  <img :src="codeSrc" alt="" class="code-img" @click="handleCode"/>
                </el-form-item>
              </div>
              <!-- 手机号登录 -->
              <div v-if="isVerification" class="verification-box">
                <el-form-item prop="phone">
                  <el-input v-model.trim="phoneRuleForm.phone" placeholder="请输入您的注册手机号" @blur="checkAll('phoneRuleForm')" class="input-phone"></el-input>
                  <img src="../assets/img/icon-mobile.png" class="login-icon" />
                  <span class="login-phone">+86</span>
                </el-form-item>
                <el-form-item prop="phoneCheckCode">
                  <el-input v-model="phoneRuleForm.phoneCheckCode" type="text" placeholder="请输入短信验证码"></el-input>
                  <div :class="[isgetCode ? 'isgetCode' : 'getCode']" @click="[isgetCode ? getVerCode(phoneRuleForm.phone) : '']">
                    {{ countDownText }}
                  </div>
                  <img src="../assets/img/icon-mobile-code.png" class="login-icon"/>
                </el-form-item>
              </div>
              <!-- 邮箱登录 -->
              <div v-if="isEmailVerification" class="verification-box">
                <el-form-item prop="email">
                  <el-input v-model.trim="emailRuleForm.email" placeholder="请输入您的注册邮箱" @blur="checkAll4Email('emailRuleForm')"></el-input>
                  <img src="../assets/img/icon-email-new.png" class="login-icon" />
                </el-form-item>
                <el-form-item prop="emailCheckCode">
                  <el-input v-model="emailRuleForm.emailCheckCode" type="text" placeholder="请输入邮箱验证码"></el-input>
                  <div :class="[isgetCode4Email ? 'isgetCode' : 'getCode']" @click="[isgetCode4Email ? getVerCode4Email(emailRuleForm.email) : '']">
                    {{ countDownText4Email }}
                  </div>
                  <img src="../assets/img/icon-email-code.png" class="login-icon"/>
                </el-form-item>
              </div>

              <!-- 登录按钮 -->
              <el-form-item class="loginBtn" v-if="isActive">
                <el-button type="primary" @click="handleLogin('ruleForm')">登 录</el-button>
              </el-form-item>
              <el-form-item class="loginBtn" v-if="isVerification">
                <el-button type="primary" @click="phoneLogin('phoneRuleForm')">登 录</el-button>
              </el-form-item>
              <el-form-item class="loginBtn" v-if="isEmailVerification">
                <el-button type="primary" @click="emailLogin('emailRuleForm')">登 录</el-button>
              </el-form-item>
              <!-- 忘记密码 -- 立即注册 -->
              <div class="logoBot">
                <div>还没有账号？<span @click="goRegister">立即注册</span></div>
                <span @click="resetPassword"> 忘记密码 </span>
              </div>
            </el-form>
          </div>
        </div>

        <!-- QQ E-mail Phone -->
        <div class="CallMe">
          <!-- QQ -->
          <el-tooltip class="item" effect="dark" placement="left" v-if="requestForm.qq.isOpen == 1 && requestForm.qq.qqlist.length > 0">
            <p slot="content" v-html="requestForm.qq.qqlist.join('<br/>')" style="line-height: 18px;"></p>
            <div class="QQ CallItem">
              <img :src="QQ_icon" alt="" />
              <span>QQ</span>
            </div>
          </el-tooltip>

          <!-- Email -->
          <el-tooltip class="item" effect="dark" placement="left" v-if="requestForm.email.isOpen == 1 && requestForm.email.emailList.length > 0">
            <p slot="content" v-html="requestForm.email.emailList.join('<br/>')" style="line-height: 18px;"></p>
            <div class="E-mail CallItem">
              <img :src="E_mail_icon" alt="" />
              <span>邮箱</span>
            </div>
          </el-tooltip>

          <!-- Phone -->
          <el-tooltip class="item" effect="dark" placement="left" v-if="requestForm.phone.isOpen == 1 && requestForm.phone.phoneList.length > 0">
            <p slot="content" v-html="requestForm.phone.phoneList.join('<br/>')" style="line-height: 18px;"></p>
            <div class="Phone CallItem">
              <img :src="Phone_icon" alt="" />
              <span>电话</span>
            </div>
          </el-tooltip>
        </div>

        <!-- 版本 -->
        <div class="copyright">
          ©1998-2024 弘成科技发展有限公司 版权所有
        </div>
      </div>

      <el-dialog title="提示" :visible.sync="noticeDialog" width="60%" center class="noticeDialog">
        <template slot="title">
          <p class="title">
            {{notice.title}}
          </p>
          <span style="font-size: 14px; margin-top: 16px;">（ {{notice.releaseTime}} ）</span>
        </template>
        <div v-html="notice.content"></div>
      </el-dialog>

    </div>
  </div>

</template>

<script>
import crypto from "crypto";
import logoSet from "@/http/logoSet.js";
import { logoDefault } from "@/http/logoSet.js";
import { imageCheckCodeOne } from "@/http/api.js";
import { checkPwd_pure, checkPhone, checkEmail } from "@/common/verify.js";
import { isgetTenantSmsConfig, getNoticeApi } from "@/http/modules/notice/notice";

export default {
  data() {
    return {
      // QQ icon 图片
      QQ_icon: require("@/assets/img/icon-QQ.png"),
      // Email icon 图片
      E_mail_icon: require("@/assets/img/Icon-Email.png"),
      // Phone icon 图片
      Phone_icon: require("@/assets/img/Icon-Tel.png"),
      // 登录方式 -- 按钮切换
      isOpenPhoneLogin: false,
      isMastPhone: false,
      isMastEmail: false,
      // 登录按钮 -- 绑定登录方式(账号/手机验证)切换
      isActive: true,
      isVerification: false,
      isEmailVerification: false,
      // 获取验证码按钮样式 -- 切换按钮
      isgetCode: false,
      isgetCode4Email: false,
      // 获取验证码按钮样式 -- 展示值
      countDownText: "获取验证码",
      countDownText4Email: "获取验证码",
      // 获取验证码按钮样式 -- 倒计时
      count: 120,
      count4Email: 120,
      // 图形验证码
      codeSrc: "",
      // 获取租户LOGO（已弃用）
      logoSrc: "",
      // 账号登录表单值
      ruleForm: {
        authMode: 1,
        userName: "",
        password: "",
        imageCheckCode: "",
        tenant: "",
      },
      //是否允许学生平台自主注册
      allowRegisterFlag: true,
      // 手机号登录表单值
      phoneRuleForm: {
        authMode: 0,
        phone: "",
        phoneCheckCode: "",
        tenant: this.$route.query.tenant ? this.$route.query.tenant: window.localStorage.getItem("tenant"),
      },
      // 邮箱登录表单值
      emailRuleForm: {
        authMode: 2,
        email: "",
        emailCheckCode: "",
        tenant: this.$route.query.tenant ? this.$route.query.tenant: window.localStorage.getItem("tenant"),
      },
      // 账号登录表单校验规则
      rules: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        imageCheckCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      // 手机号登录表单校验规则
      phoneRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          { validator: checkPhone, trigger: "change" },
        ],
        phoneCheckCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
      // 手机号登录表单校验规则
      emailRules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: "change" },
          { validator: checkEmail, trigger: "change" },
        ],
        emailCheckCode: [
          { required: true, message: "请输入邮箱验证码", trigger: "blur" },
        ],
      },
      // 自定义绑定数据

      backgroundVoList_Default: [
        {
          imageSubtitle: "支持多种考试模式，助力完成严肃性考试，包括线上和线下两种场景的，全流程的考试解决方案。",
          imageTitle: "弘成慧考平台助力严肃性考试",
          imageUrl: require("@/assets/img/Swiper.jpg"),
        },
      ],

      requestForm: {
        systemName: "",
        logoUrl: "",
        isUsedLogo: 0,
        backgroundVoList: [],
        qq: {
          qqlist: [],
          isOpen: "",
        },
        email: {
          emailList: [],
          isOpen: "",
        },
        phone: {
          phoneList: [],
          isOpen: "",
        },
      },
      // 公告
      notice: {},
      noticeDialog: false,
      noticeShow: false,
      noticeNew: '',
    };
  },
  watch: {
    // 存取租户名 | 刷新登录页
    $route: {
      handler: function() {
        const tmpQueryTenant = this.$route.query.tenant;
        const tmpLocalTenant = window.localStorage.getItem("tenant");
        if (tmpQueryTenant) {
          window.localStorage.setItem("tenant", tmpQueryTenant);
        }else{
          if(tmpLocalTenant){
            this.$router.push({ path: `/login?tenant=${tmpLocalTenant}` ,query: { tenant: tmpLocalTenant }});
          }
        }
        if (this.$route.query.refresh) window.location.reload()
        this.ruleForm.tenant = window.localStorage.getItem("tenant")
        this.phoneRuleForm.tenant = window.localStorage.getItem("tenant")
        this.emailRuleForm.tenant = window.localStorage.getItem("tenant")
      },
      immediate: true
    },
  },
  async created() {
    // 浏览器类型校验
    await this.dealIE();
    // 路由重置
    await this.$store.dispatch("permission/resetRoutesAction");

    await this.isOtsUser();

    // 获取手机号登录倒计时
    let myEndTime = localStorage.getItem("myEndTime")
    myEndTime && this.codeCountDown(myEndTime)
    // 获取邮箱登录倒计时
    let myEndTime4Email = localStorage.getItem("myEndTime4Email")
    myEndTime4Email && this.codeCountDown4Email(myEndTime4Email)
  },
  mounted() {
    // 获取图形验证码
    this.codeSrc = `${imageCheckCodeOne}?time=${Math.random()}`;
    // 回车登录
    document.addEventListener("keydown", (e) => {
      if (e.keyCode === 13) {
        if (this.isActive) {
          this.handleLogin("ruleForm");
        } else {
          if(this.isVerification){
            this.phoneLogin("phoneRuleForm");
          }else{
            this.emailLogin("emailRuleForm");
          }
        }
      }
    });
    // 是否开启手机验证码登录功能
    this.isOpenPhoneVcode();
    // 获取自定义信息
    this.getLoginInfo();
    // 公告
    this.getNotice();
  },

  filters: {
    /**
     * @param { 超过20位显示 ... }
     */
    ellipsis: function (value) {
      if (!value) return "";
      if (value.length > 20) return value.slice(0, 20) + '...'
      return value
    }
  },

  computed: {
    getShowNavigation() {
      if(this.isOpenPhoneLogin){
        if(this.isMastPhone || this.isMastEmail){
          return true;
        }else{
          return false;
        }
      }else{
        return false;
      }
    }
  },

  methods: {
    // 其它平台用户连接 ?
    isOtsUser() {
      if (!this.$route.query.loginType) {
        return false;
      }
      let { query } = this.$route;
      window.localStorage.setItem("tenant", query.tenant);
      window.localStorage.setItem("userInfo", JSON.stringify(query));
      if (query.roleType == 1) {
        this.$router.push({ name: "index" });
      } else {
        query.cpwd = "NoChange";
        if (query.planId) {
          this.$router.push({ name: "home", query });
          sessionStorage.setItem("planId", query.planId);
        } else {
          this.$router.push({ name: "batch", query: { cpwd: "NoChange" }});
        }
      }
    },

    // 获取公告
    async getNotice() {
      let tenant = window.localStorage.getItem("tenant")
      let { data: notice } = await getNoticeApi({tenant})
      this.noticeShow = notice ? true: false
      if (!notice) return
      notice.releaseTime = notice.releaseTime.replace('T',' ').slice(0, 10)
      this.notice = notice
      this.noticeNew = notice.title + notice.content
    },

    // 获取自定义信息
    getLoginInfo() {
      let params = this.phoneRuleForm.tenant;
      this.$api.system.getSystemNameFN({ tenant: params }).then((res) => {
          this.requestForm.logoUrl = res.data.isUsedLogo == 1 ? res.data.logoUrl ? res.data.logoUrl : require("@/assets/img/customDefault.png") : require("@/assets/img/customDefault.png");
          this.requestForm.systemName = res.data.systemName ? res.data.systemName : "弘成慧考";
          this.requestForm.loginPageTitle = res.data.loginPageTitle ? res.data.loginPageTitle: "";
          this.requestForm.backgroundVoList = res.data.backgroundVoList ? res.data.backgroundVoList: this.backgroundVoList_Default;
          this.requestForm.qq = res.data.qq;
          this.requestForm.email = res.data.email;
          this.requestForm.phone = res.data.phone;

          this.requestForm.qq.qqlist = res.data.qq.qqlist
            ? res.data.qq.qqlist
            : [];
          this.requestForm.email.emailList = res.data.email.emailList
            ? res.data.email.emailList
            : [];
          this.requestForm.phone.phoneList = res.data.phone.phoneList
            ? res.data.phone.phoneList
            : [];
          this.allowRegisterFlag = res.data.allowRegister == 1 ? true : false;

          let phoneObj = res.data.baseDefList.find((item) => item.fieldName == "phone");
          if(phoneObj) this.isMastPhone = phoneObj.required == 1 ? true : false;
          let emailObj = res.data.baseDefList.find((item) => item.fieldName == "email");
          if(emailObj) this.isMastEmail = emailObj.required == 1 ? true : false;
        })
        .catch((err) => {
          this.requestForm.systemName = "弘成慧考";
          this.requestForm.logoUrl = require("@/assets/img/customDefault.png");
        });
    },

    // 是否开启手机验证码登录功能
    isOpenPhoneVcode() {
      const tenant = this.phoneRuleForm.tenant;
      isgetTenantSmsConfig({ tenant })
        .then((res) => {
          if (res.code == 1) {
            if (res.data.loginCheck == 1) {
              this.isOpenPhoneLogin = true;
            } else {
              this.isOpenPhoneLogin = false;
            }
          } else {
            this.isOpenPhoneLogin = false;
          }
        })
        .catch(() => {
          this.isOpenPhoneLogin = false;
        });
    },

    // 切换登录方式
    changeMode(v) {
      if(v == "account") {
        this.isActive = true;
        this.isVerification = false;
        this.isEmailVerification = false;
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate()
        })
      }else if(v == "verification") {
        this.isActive = false;
        this.isVerification = true;
        this.isEmailVerification = false;
        this.$nextTick(() => {
          this.$refs.phoneRuleForm.clearValidate()
        })
      }else{
        this.isActive = false;
        this.isVerification = false;
        this.isEmailVerification = true;
        this.$nextTick(() => {
          this.$refs.emailRuleForm.clearValidate()
        })
      }

    },

    // 是否开启获取手机验证码按钮
    checkAll(formName) {
      this.$refs[formName].validateField(["phone"], (valid) => {
        if (!valid) {
          this.isgetCode = valid ? false : true;
        } else {
          this.isgetCode = false;
        }
      });
    },
    // 是否开启获取邮箱验证码按钮
    checkAll4Email(formName) {
      this.$refs[formName].validateField(["email"], (valid) => {
        if (!valid) {
          this.isgetCode4Email = valid ? false : true;
        } else {
          this.isgetCode4Email = false;
        }
      });
    },

    // 获取手机验证码
    getVerCode(state) {
      if (state) {
        let type = 1
        let { phone, tenant } = this.phoneRuleForm
        this.$api.login.phoneCheckCode({ phone, email:'', type, tenant }).then((res) => {
          if (res.code == 1) this.GetCode()
        })
      } else {
        return false
      }
    },
    // 获取邮箱验证码
    getVerCode4Email(state) {
      if (state) {
        let type = 1
        let { email, tenant } = this.emailRuleForm
        this.$api.login.phoneCheckCode({ phone:'', email, type, tenant }).then((res) => {
          if (res.code == 1) this.GetCode4Email()
        })
      } else {
        return false
      }
    },

    // 倒计时存入缓存,防止刷新重置
    GetCode() {
      let endMsRes = new Date().getTime() + 120000
      localStorage.setItem("myEndTime", JSON.stringify(endMsRes))
      this.codeCountDown(endMsRes)
    },
    // 倒计时存入缓存,防止刷新重置
    GetCode4Email() {
      let endMsRes = new Date().getTime() + 120000
      localStorage.setItem("myEndTime4Email", JSON.stringify(endMsRes))
      this.codeCountDown4Email(endMsRes)
    },

    // 倒计时计算,清除缓存和定时器
    codeCountDown(endMsRes) {
      this.isgetCode = false;
      this.countDownText = this.count + "秒后获取";
      this.count = Math.ceil((endMsRes - new Date().getTime()) / 1000);
      let time = setTimeout(() => {
        this.count--;
        if (this.count < 1) {
          this.isgetCode = true;
          this.countDownText = "获取验证码";
          this.count = 120;
          localStorage.removeItem("myEndTime");
          clearTimeout(time);
        } else {
          this.codeCountDown(endMsRes);
        }
      }, 1000);
    },

    // 倒计时计算,清除缓存和定时器
    codeCountDown4Email(endMsRes) {
      this.isgetCode4Email = false;
      this.countDownText4Email = this.count4Email + "秒后获取";
      this.count4Email = Math.ceil((endMsRes - new Date().getTime()) / 1000);
      let time = setTimeout(() => {
        this.count4Email--;
        if (this.count4Email < 1) {
          this.isgetCode4Email = true;
          this.countDownText4Email = "获取验证码";
          this.count4Email = 120;
          localStorage.removeItem("myEndTime4Email");
          clearTimeout(time);
        } else {
          this.codeCountDown4Email(endMsRes);
        }
      }, 1000);
    },

    // 手机验证码登录
    phoneLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.phoneRuleForm.tenant) {
            this.$message({
              message: "地址错误，请输入正确的地址！",
              type: "error",
            });
            return false;
          }
          this.$api.login.login(this.phoneRuleForm).then((res) => {
            if (res.code) {
              let userInfo = JSON.stringify(res.data);
              localStorage.setItem("userInfo", userInfo);
              localStorage.setItem("tenant", this.phoneRuleForm.tenant);
              this.$message({
                message: "登录成功",
                type: "success",
              });
              if (res.data.roleType === 2) {
                this.$router.push({ name: "batch" });
              } else if (res.data.roleType == 6) {
                this.$router.push({ name: "signing" });
              } else {
                this.$router.push({ name: "index" });
              } 
            }
          });
        } else {
          return false;
        }
      });
    },
    // 邮箱验证码登录
    emailLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.emailRuleForm.tenant) {
            this.$message({
              message: "地址错误，请输入正确的地址！",
              type: "error",
            });
            return false;
          }
          this.$api.login.login(this.emailRuleForm).then((res) => {
            if (res.code) {
              let userInfo = JSON.stringify(res.data);
              localStorage.setItem("userInfo", userInfo);
              localStorage.setItem("tenant", this.emailRuleForm.tenant);
              this.$message({
                message: "登录成功",
                type: "success",
              });
              if (res.data.roleType === 2) {
                this.$router.push({ name: "batch" });
              } else if (res.data.roleType == 6) {
                this.$router.push({ name: "signing" });
              } else {
                this.$router.push({ name: "index" });
              } 
            }
          });
        } else {
          return false;
        }
      });
    },

    // 判断是否是IE浏览器
    dealIE() {
      if (window.isIE) {
        this.$confirm(
          "检测到当前浏览器适配较差，为更好的使用系统，推荐使用谷歌浏览器，如果是360，搜狗等浏览器，请切换极速模式后刷新页面使用。",
          "重要提示",
          {
            confirmButtonText: "下载谷歌浏览器",
            cancelButtonText: "换浏览器打开",
            type: "warning",
          }
        )
          .then(async () => {
            window.location.href = "https://www.google.cn/intl/zh-CN/chrome/";
          })
          .catch(() => {
            window.close();
          });
      }
    },

    // 获取租户_Logo
    getLogo() {
      const tenant = this.ruleForm.tenant;
      logoSet("login", tenant)
        .then(({ code, data }) => {
          if (code == 1) {
            this.logoSrc = data;
          } else {
            this.logoSrc = logoDefault("login");
          }
        })
        .catch(() => {
          this.logoSrc = logoDefault("login");
        });
    },

    // 获取验证码
    handleCode() {
      this.codeSrc = `${imageCheckCodeOne}?time=${Math.random()}`;
    },

    // 账号密码登录
    handleLogin(formName) {
      /**
       * 租户 Code tenant
       * 用户名 userName
       * 密码 passWord
       */
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.userName = this.ruleForm.userName.trim();
          let { password, ...parmas } = this.ruleForm;
          let md5Password = password;
          const md5 = crypto.createHash("md5");
          md5.update(md5Password);
          md5Password = md5.digest("hex");
          let queryRuleForm = {
            password: md5Password,
            ...parmas,
          };
          if (!this.ruleForm.tenant) {
            this.$message({
              message: "地址错误，请输入正确的地址",
              type: "error",
            });
            return false;
          }
          this.$api.login.login(queryRuleForm).then((res) => {
            if (res.code) {
              let userInfo = JSON.stringify(res.data);
              localStorage.setItem("userInfo", userInfo);
              if (res.data.roleType !== 2) {
                this.$message({
                  message: "登录成功",
                  type: "success",
                });
              }
              window.localStorage.setItem("tenant", this.ruleForm.tenant);

              // 密码到期：学生端强制修改密码
              if (res.data.isPassWordExpired === 1 && res.data.roleType === 2) {
                if(this.isMastPhone || this.isMastEmail){//如果开放了手机号或者邮箱必填，则转到修改密码页面
                  this.$router.push({name: 'userConfig'});
                }else{ //如果手机号和邮箱都没有必填，则退出登录并弹错误框提示
                  //this.$router.push({ name: "batch" });
                  window.localStorage.removeItem('userInfo');
                  this.$api.login.outLogin();
                  this.$message({
                    message: "密码已过期，请联系管理员重置",
                    type: "error",
                  });
                  return false;
                }
                return;
              } else {
                if (res.data.roleType === 2) {
                  this.goStudent(password);
                } else if (res.data.roleType === 5) {
                  this.$router.push({ name: "review" });
                } else if (res.data.roleType === 6) {
                  this.$router.push({ name: "signing" });
                } else {
                  this.$router.push({ name: "index" });
                }
              }
            } else {
              this.codeSrc = `${imageCheckCodeOne}?time=${Math.random()}`;
              this.ruleForm.imageCheckCode = "";
            }
          });
        } else {
          return false;
        }
      });
    },

    // 学生端=>是否修改密码
    goStudent(password) {
      const isPass = checkPwd_pure(password);
      if (isPass) {
        this.$router.push({ name: "batch", query: { cpwd: "NoChange" } });
      } else {
        this.$router.push({ name: "batch", query: { cpwd: "IsChange" } });
      }
    },

    // 立即注册
    goRegister() {
      if(!this.allowRegisterFlag){
        this.$message.error('注册入口已关闭');
        return;
      }
      if(this.isMastPhone || this.isMastEmail){
        this.$router.push({
          name: "register",
          query: { tenant: this.ruleForm.tenant },
        });
      }else{
        this.$message.error('注册入口已关闭');
        return;
      }
    },

    // 忘记密码
    resetPassword() {
      if(this.isMastPhone || this.isMastEmail){
        this.$router.push({
          name: "resetPassword",
          query: { tenant: this.ruleForm.tenant },
        });
      }else{
        this.$message.error('忘记密码入口已关闭');
        return;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.noticeDialog {
  p {
    color: #45494D; 
    font-size: 24px; 
    font-family: 'PingFangSC-Medium, PingFang SC'; 
    width: 90%; 
    margin: 0 auto; 
    text-align: center; 
  }
  div {
    line-height: 24px;
  }
}

#login {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}

.importantNote {
  width: 100%;
  font-size: 14px;
  color: #ff9500;
  margin-top: -7px;
  display: flex;
  align-items: center;
  img {
    margin-right: 16px;
    width: 20px;
    height: 20px;
  }
}

/deep/ .el-alert__closebtn {
  top: 14px;
  color: #ff9500;
}

/deep/ .el-dialog{
  border-radius: 8px;
  min-width: 720px;
  max-height: 72vh;
  overflow: auto;
}

.el-alert {
  padding-right: 0;
}

/deep/ .el-alert__content {
  width: 100%;
}

// 1920 * 1080
.NewLogin {
  width: 100%;
  height: 100%;
  min-height: 920px;
  background: url("../assets/img/newbackground.png") top center no-repeat;
  background-size: 100% 55%;
  .NewLogo {
    max-width: 280px;
    height: 48px;
    margin-top: 36px;
    margin-left: 48px;
    &>img {
      height: 100%;
    }
  }
  // 中心报名框架(Swiper + Login)
  .NewMainLogin {
    width: 1440px;
    height: 760px;
    margin: 24px auto 0;
    border-radius: 8px;
    box-shadow: 0px 0px 80px 0px rgba(17, 36, 105, 0.12);
    overflow: hidden;
    display: flex;
    // 左侧外框
    .NewLeft {
      width: 920px;
      height: 100%;
      // 轮播图外框
      .NewSwiper {
        width: 100%;
        height: 100%;
        background: #fff;

        // 轮播图
        /deep/ .el-carousel__container {
          height: 760px;

          // Swiper 切换样式修改
          .el-carousel__item.is-animating {
            opacity: 1;
            transition: opacity 2s linear !important;
          }

          .el-carousel__item {
            opacity: 0.1;
            transition: opacity 1s linear !important;
          }

          // Swiper 文字描述
          .el-carousel__item,
          .el-carousel__item.is-animating {
            .SwiperText {
              padding: 40px 48px;
              box-sizing: border-box;
              position: absolute;
              bottom: 0;
              width: 100%;
              min-height: 190px;
              .SwiperTitle {
                font-size: 26px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: bold;
                color: #fff;
                height: auto;
                line-height: 30px;
                text-shadow: 0px 0px 80px rgba(17, 36, 105, 0.12),
                  0px 2px 6px rgba(0, 0, 0, 0.5);
              }
              .SwiperDes {
                color: #fff;
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                line-height: 26px;
                margin-top: 20px;
                text-shadow: 0px 0px 80px rgba(17, 36, 105, 0.12);
              }
            }
          }

          .el-carousel__arrow.el-carousel__arrow--left,
          .el-carousel__arrow.el-carousel__arrow--right {
            display: none;
          }
        }

        // 指示器
        /deep/ .el-carousel__indicators--horizontal {
          position: absolute;
          left: auto;
          right: 16px;
          bottom: 0;
          .el-carousel__indicator--horizontal button {
            width: 4px;
            height: 4px;
            border-radius: 50%;
          }
          .el-carousel__indicator--horizontal.is-active button {
            width: 16px;
            height: 4px;
            border-radius: 2px;
          }
        }
      }
    }

    .NewRight {
      width: 520px;
      height: 100%;
      background: #fff;
      padding: 0 70px;
      box-sizing: border-box;
      .loginPageTitle {
        width: 100%;
        // height: 40px;
        text-align: center;
        margin-top: 56px;
        margin-bottom: 8px;
        text-shadow: 0px 0px 80px rgba(17,36,105,0.12);
      }
      // 登录标题
      h1 {
        text-align: center;
        width: 100%;
        height: auto;
        font-size: 28px;
        font-weight: 600;
        color: #2d2f33;
        margin-top: 120px;
        margin-bottom: 52px;
        text-shadow: 0px 0px 80px rgba(17, 36, 105, 0.12);
      }
      .changeBenFirst.changeBtn {
        margin-bottom: 48px;
      }
      @media screen and (max-width: 1900px) {
        .changeBenFirst.changeBtn {
          margin-bottom: 24px;
        }
      }

      // 切换登录方式
      .changeBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 28px;
        .account {
          margin-left: 20px;
          margin-right: 20px;
          color: #737780;
          font-weight: 500;
          box-shadow: 0px 0px 80px 0px rgba(17, 36, 105, 0.12);
          cursor: pointer;
        }
        .verification {
          margin-right: 20px;
          color: #737780;
          font-weight: 500;
          box-shadow: 0px 0px 80px 0px rgba(17, 36, 105, 0.12);
          cursor: pointer;
        }
        .emailVerification {
          margin-right: 20px;
          color: #737780;
          font-weight: 500;
          box-shadow: 0px 0px 80px 0px rgba(17, 36, 105, 0.12);
          cursor: pointer;
        }
        .changeCenter {
          margin-right: 20px;
          color: #737780;
          font-weight: 500;
        }
        .active {
          color: #0b66e6;
          position: relative;
          cursor: pointer;
        }
        .active::after {
          content: "";
          position: absolute;
          left: 50%;
          top: auto;
          bottom: -4px;
          right: auto;
          height: 2px;
          width: 18px;
          background-color: #0b66e6;
          transform: translate(-50%);
        }
      }
      // 表单
      .el-form.demo-ruleForm {
        /deep/ .el-form-item__content {
          margin-left: 0 !important;
        }
        .el-form-item {
          position: relative;
          margin-bottom: 34px;
          .input-phone /deep/ .el-input__inner {
            border: 0 !important;
            border-bottom: 1px solid #e6e9f2 !important;
            background: transparent;
            border-radius: 0;
            width: 100%;
            height: 40px;
            padding: 8px 30px 8px 74px !important;
            line-height: 24px;
          }
          .login-icon {
            width: 24px;
            height: 24px;
            position: absolute;
            top: 8px;
            left: 6px;
            color: #c2c6cc;
          }
          .login-phone {
            width: 24px;
            height: 40px;
            color: #333 !important;
            position: absolute;
            left: 32px;
            color: #c2c6cc;
          }
          i {
            position: absolute;
            top: 14px;
            left: 10px;
            color: #c2c6cc;
          }
          /deep/ .el-input {
            width: 100%;
            height: 40px;
            line-height: 40px;
          }
          /deep/ .el-input__inner {
            border: 0 !important;
            border-bottom: 1px solid #e6e9f2 !important;
            background: transparent;
            border-radius: 0;
            width: 100%;
            height: 40px;
            padding: 8px 30px 8px 34px !important;
            line-height: 24px;
          }
          /deep/ .el-input__inner:focus {
            border-bottom: 1px solid #c2c6cc !important;
          }
          .code-img {
            position: absolute;
            top: 8px;
            right: 10px;
            width: 80px;
            height: 30px;
          }
          /deep/ .el-button--primary {
            span {
              font-size: 20px;
            }
            width: 100%;
            height: 48px;
            border-radius: 26px;
          }
          /deep/ .el-button--primary:hover {
            background-color: #2680ff;
          }
        }

        /* ***** 获取验证码按钮样式 ***** */
        .isgetCode {
          text-align: right;
          font-size: 14px;
          line-height: 20px;
          width: 84px;
          height: 20px;
          position: absolute;
          right: 12px;
          top: 10px;
          color: #006aff;
          cursor: pointer;
        }
        .getCode {
          text-align: right;
          font-size: 14px;
          line-height: 20px;
          width: 84px;
          height: 20px;
          position: absolute;
          right: 12px;
          top: 10px;
          color: #9299a6;
          cursor: not-allowed;
        }
        // 提交按钮
        .loginBtn {
          margin-top: 36px;
        }
        .logoBot {
          display: flex;
          justify-content: space-between;
          color: #9299a6;
          font-size: 14px;
          span {
            color: #006aff;
            cursor: pointer;
          }
        }
      }
    }
  }
}

// QQ E-mail Phone 固定定位
.CallMe {
  width: 64px;
  height: auto;
  position: fixed;
  right: 16px;
  bottom: 160px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(15, 34, 102, 0.08);
  border-radius: 4px;
  .CallItem {
    width: 100%;
    height: 76px;
    padding-top: 16px;
    box-sizing: border-box;
    img {
      display: block;
      width: 24px;
      height: 24px;
      margin: 0 auto;
    }
    span {
      width: 100%;
      display: block;
      color: #9299a6;
      font-size: 14px;
      line-height: 20px;
      margin-top: 8px;
      text-align: center;
    }
  }
  .CallItem:hover {
    span {
      color: #006aff;
      font-weight: 700;
    }
  }
}

@media screen and (max-width: 3199px) {
  .NewLogin {
    height: auto;
    min-height: 780px;
    .NewMainLogin {
      width: 1180px;
      height: 620px;
      margin-top: 24px;
      .NewLeft {
        width: 740px;
        height: 100%;
        .NewSwiper {
          /deep/ .el-carousel__container {
            height: 620px;
          }
        }
      }
      .NewRight {
        width: 440px;
        padding: 0 56px;
        h1 {
          margin-top: 60px;
        }
      }
    }
  }
}

// 登录框媒体查询
@media screen and (max-width: 1900px) {
  .NewLogin {
    min-height: 640px;
    .NewLogo {
      max-width: 280px;
      height: 48px;
      margin-top: 16px;
      margin-left: 36px;
      &>img {
        height: 100%;
      }
    }
    .NewMainLogin {
      width: 1024px;
      height: 560px;
      margin-top: 16px;
      .NewLeft {
        width: 600px;
        height: 100%;
        .NewSwiper {
          /deep/ .el-carousel__container {
            height: 560px;
          }
        }
      }
      .NewRight {
        width: 424px;
        padding: 0 56px;
        h1 {
          margin-top: 48px;
          margin-bottom: 24px;
        }
      }
    }
  }
}

.copyright {
  margin: 0 auto;
  padding: 24px 0;
  font-size: 14px;
  color: #9299a6;
  text-align: center;
  // position: absolute;
  // left: 50%;
  // bottom: 24px;
  // transform: translateX(-50%);
}
</style>
